module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("KATIE COLLINS NEEDS TO LISTEN TO HER MAMA'S WISDOM:")]), _c('p', {
    staticClass: "nl1"
  }, [_vm._v("1. Love makes us do amazing, wonderful things…and really stupid things too.")]), _c('p', {
    staticClass: "nl"
  }, [_vm._v("2. A little restraint is fine…as long as you don't overdo it.")]), _c('p', {
    staticClass: "nl"
  }, [_vm._v("3. The most important thing you can do in life is to be your best you.")]), _c('p', {
    staticClass: "nl"
  }, [_vm._v("4. Don't waste time on a man unless his kiss makes you forget your name!")]), _c('p', {
    staticClass: "nl3"
  }, [_vm._v("5. I'd rather be brave enough to do something worthy of wild gossip than be so afraid of others’ disapproval that I do nothing at all.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a2444a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SomeGirlsDo_pref-1.vue
// module id = 69
// module chunks = 0